import { useRef } from 'react';
import { useToggle } from '@packlink/utils';
import { IconNames } from '@shipengine/giger-theme';
import { useTranslation } from '@packlink/translation-provider';
import { Button, ButtonSize, ButtonVariant, Popover, Icon, IconSize, Typography, ButtonColor } from '@shipengine/giger';
import { getPopoverStyles, getContentStyles, getIconStyles, getQuestionStyles } from './DeleteVaultStyles.js';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';

const DeleteVault = _ref => {
  let {
    onDelete
  } = _ref;
  const {
    t
  } = useTranslation();
  const buttonRef = useRef(null);
  const {
    state: isOpen,
    toggle: toggleIsOpen
  } = useToggle(false);
  const handleConfirm = () => {
    onDelete();
    toggleIsOpen();
  };
  return jsxs(Fragment, {
    children: [jsx(Button, {
      isFullWidth: true,
      ref: buttonRef,
      onClick: toggleIsOpen,
      size: ButtonSize.SMALL,
      variant: ButtonVariant.TEXT,
      children: t('payment-options.button.delete')
    }), jsx(Popover, {
      isOpen: isOpen,
      reference: buttonRef.current,
      onClickAway: toggleIsOpen,
      css: getPopoverStyles,
      children: jsxs("section", {
        css: getContentStyles,
        children: [jsx(Icon, {
          name: IconNames.ALERT,
          size: IconSize.SIZE_SMALL,
          css: getIconStyles
        }), jsxs("section", {
          children: [jsx(Typography, {
            variant: "body2",
            children: t('payment-options.delete.warning-message')
          }), jsx(Typography, {
            variant: "body2",
            component: "p",
            bold: true,
            css: getQuestionStyles,
            children: t('payment-options.delete.warning-question')
          }), jsxs("section", {
            children: [jsx(Button, {
              onClick: handleConfirm,
              color: ButtonColor.ERROR,
              size: ButtonSize.SMALL,
              variant: ButtonVariant.TEXT,
              children: t('payment-options.button.confirm-delete')
            }), jsx(Button, {
              onClick: toggleIsOpen,
              color: ButtonColor.SECONDARY,
              size: ButtonSize.SMALL,
              variant: ButtonVariant.TEXT,
              isInactive: true,
              children: t('payment-options.button.cancel')
            })]
          })]
        })]
      })
    })]
  });
};

export { DeleteVault };
//# sourceMappingURL=DeleteVault.js.map
